module.exports = __webpack_public_path__ + "img/timestamp3.0ba8314a.png";